import { Box, Button, Typography } from "@mui/material";
import WifiOff from "@mui/icons-material/WifiOff";
import { useQueryClient } from "@tanstack/react-query";
import React from "react";

/**
 * Fallback shown when a page's data can't load due to a network error.
 *
 * Uses an inline MUI icon (bundled into the JS) rather than a fetched image — the
 * artwork must render while offline, and the service worker no longer caches assets.
 */
export default function Offline() {
  const queryClient = useQueryClient();

  return (
    <Box
      sx={{
        pt: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
      }}
    >
      <WifiOff sx={{ fontSize: 96, color: "text.secondary", mb: 1 }} />
      <Typography variant="h6">
        <b>You're offline</b>
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Please check your connection and try again
      </Typography>
      {/* Refetch in place rather than window.location.reload(): a full reload
          re-fetches index.html over the network, which fails while offline (no
          cached app shell) and dumps the user onto the browser/PWA offline page.
          Refetching keeps the loaded SPA and just retries the failed queries. */}
      <Button
        variant="contained"
        onClick={() => queryClient.refetchQueries()}
        sx={{ mt: 1 }}
      >
        Retry
      </Button>
    </Box>
  );
}
